// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1GncS","requiredAsterisk":"Info_requiredAsterisk__iciAW"};